import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './ResumenPage.css';

function ResumenPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const orderDetails = location.state;

  if (!orderDetails || !orderDetails.items || orderDetails.items.length === 0) {
    return (
      <div className="resumen-page">
        <h2>Resumen de la Compra</h2>
        <p>No hay detalles de la orden.</p>
        <button onClick={() => navigate('/')} className="finalize-button">
          Volver al inicio
        </button>
      </div>
    );
  }

  const { items, subtotal, deliveryCost, totalAmount, event } = orderDetails;

  return (
    <div className="resumen-page">
      <h2>Resumen de la Compra</h2>
      <p>Gracias por tu compra! Un correo de confirmación fue enviado a tu dirección de correo electrónico.</p>

      <div className="resumen-items-container">
        {items.map((item, index) => {
          const quantity = item.quantity ?? 1;
          const price = item.price ?? 0;
          const handlingFee = item.handlingFee ?? 0;
          const totalWithHandling = (price + handlingFee) * quantity;

          return (
            <div key={index} className="resumen-item-box">
              <div className="resumen-item-card">
                <p><strong>Evento:</strong> {event ?? "Evento Desconocido"}</p>
                <p><strong>Área:</strong> {item.eventArea ?? "Área Desconocida"}</p>
                <p><strong>Cantidad:</strong> {quantity}</p>
                <p><strong>Precio Unitario:</strong> RD${price.toFixed(2)}</p>
                <p><strong>Cargo de Manejo:</strong> RD${handlingFee.toFixed(2)}</p>
                <p><strong>Tipo de Ticket:</strong> {item.deliveryOption ?? "Digital"}</p>
                <p><strong>Total:</strong> RD${totalWithHandling.toFixed(2)}</p>
              </div>
            </div>
          );
        })}
      </div>

      <div className="resumen-summary">
        <p><strong>Subtotal:</strong> RD${subtotal ?? 0}</p>
        <p><strong>Costo Total Cargos:</strong> RD${deliveryCost ?? 0}</p>
        <p><strong>Total a pagar:</strong> RD${totalAmount ?? 0}</p>
      </div>

      <button onClick={() => navigate('/')} className="finalize-button">
        Finalizar
      </button>
    </div>
  );
}

export default ResumenPage;